"use client";

import { useState } from "react";
import Loading from "@/components/Loading";
import {
  dreamnDisplayValue,
  DreamnOtherBetsStatus,
} from "../DreamnOtherBetsHelpers";

export default function DreamnOtherBetsDropdown({
  loadingOtherOdds,
  otherOddsData,
  hasOtherData,
  isLive,
  goalOddEvenOdds = [],
  goalOddEvenFirst = {},
  correctScoresListFull = [],
  correctScoresFull = { home: [], draw: [], away: [] },
  correctScoresListHalf = [],
  correctScoresHalf = { home: [], draw: [], away: [] },
  totalCornersOdds = [],
  totalCornersHalfOdds = [],
  fontBody = "text-xs md:text-sm",
}) {
  const [activeOtherTab, setActiveOtherTab] = useState("full");

  return (
    <div className="px-0 md:px-1  py-2 pt-3 pb-4 min-w-0 overflow-hidden w-full">
      {loadingOtherOdds && !otherOddsData && (
        <div className="w-full py-4">
          <Loading />
        </div>
      )}
      {!loadingOtherOdds && otherOddsData && !hasOtherData && (
        <div
          className={`w-full py-2 text-center text-[var(--theme-text-muted)] ${fontBody}`}
        >
          Chưa có dữ liệu kèo cược khác
        </div>
      )}
      {!loadingOtherOdds && hasOtherData && (
        <div
          className={`flex flex-col gap-0 min-w-0 overflow-hidden rounded-lg border border-[var(--theme-border)] bg-[var(--theme-foreground)] ${isLive ? "ring-1 ring-[var(--theme-primary)]/20" : ""}`}
        >
          <div className="w-full border-b border-[var(--theme-border)] bg-[var(--theme-accent)]/40 px-1 py-2">
            <ul className="m-0 flex w-full max-w-[220px] list-none p-0">
              <li className="w-1/2 shrink-0 list-none">
                <button
                  type="button"
                  onClick={() => setActiveOtherTab("full")}
                  className={`w-full py-2 px-2 md:px-3 font-bold ${fontBody} border-0 transition-colors ${
                    activeOtherTab === "full"
                      ? "bg-[var(--theme-primary)] text-[var(--theme-on-primary)]"
                      : "bg-transparent text-[var(--theme-text-muted)] hover:text-[var(--theme-text)]"
                  }`}
                >
                  Cả trận
                </button>
              </li>
              <li className="w-1/2 shrink-0 list-none">
                <button
                  type="button"
                  onClick={() => setActiveOtherTab("half")}
                  className={`w-full py-2 px-2 md:px-3 font-bold ${fontBody} border-0 transition-colors ${
                    activeOtherTab === "half"
                      ? "bg-[var(--theme-primary)] text-[var(--theme-on-primary)]"
                      : "bg-transparent text-[var(--theme-text-muted)] hover:text-[var(--theme-text)]"
                  }`}
                >
                  Hiệp 1
                </button>
              </li>
            </ul>
          </div>

          <div className="p-2.5 flex flex-col gap-3">
            {activeOtherTab === "full" && (
              <>
                {goalOddEvenOdds?.length > 0 && (
                  <div className="flex flex-col gap-1">
                    <div
                      className={`font-bold text-[var(--theme-text-muted)] ${fontBody}`}
                    >
                      Odd/Even
                    </div>
                    <div className="flex flex-wrap gap-2">
                      <div className="flex flex-col items-center gap-0.5">
                        <span className="text-[10px] text-[var(--theme-text-muted)]">
                          Odd
                        </span>
                        <span
                          className={`flex items-center justify-center gap-1 rounded-md py-1 px-2 min-w-[4rem] font-bold border border-[var(--theme-border)] bg-[var(--theme-bg)] text-[var(--theme-text)] ${fontBody}`}
                        >
                          {dreamnDisplayValue(goalOddEvenFirst?.single)}
                          <DreamnOtherBetsStatus
                            trend={goalOddEvenFirst?.initialSingleTrend}
                          />
                        </span>
                      </div>
                      <div className="flex flex-col items-center gap-0.5">
                        <span className="text-[10px] text-[var(--theme-text-muted)]">
                          Even
                        </span>
                        <span
                          className={`flex items-center justify-center gap-1 rounded-md py-1 px-2 min-w-[4rem] font-bold border border-[var(--theme-border)] bg-[var(--theme-bg)] text-[var(--theme-text)] ${fontBody}`}
                        >
                          {dreamnDisplayValue(goalOddEvenFirst?.double)}
                          <DreamnOtherBetsStatus
                            trend={goalOddEvenFirst?.initialDoubleTrend}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                {correctScoresListFull.length > 0 && (
                  <div className="flex flex-col gap-1">
                    <div
                      className={`font-bold text-[var(--theme-text-muted)] ${fontBody}`}
                    >
                      Tổng tỷ số
                    </div>
                    <div className="grid grid-cols-3 gap-1 mb-0.25 text-center font-bold text-[10px] text-[var(--theme-text-muted)]">
                      {correctScoresFull.home?.length > 0 && (
                        <div className="py-1.5 px-2">Tỉ Số Thắng Đội Nhà</div>
                      )}
                      {correctScoresFull.draw?.length > 0 && (
                        <div className="py-1.5 px-2">Tỉ Số Hòa</div>
                      )}
                      {correctScoresFull.away?.length > 0 && (
                        <div className="py-1.5 px-2">Tỉ Số Thắng Đội Khách</div>
                      )}
                    </div>
                    <div className="max-h-[250px] overflow-y-auto min-h-0">
                      <div className="grid grid-cols-3 gap-2.5">
                        {correctScoresFull.home?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresFull.home.map((item, idx) => (
                              <div
                                key={idx}
                                className="flex flex-col gap-1.5 min-w-0 shrink-0"
                              >
                                <div
                                  className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}
                                >
                                  {item.label}
                                </div>
                                <div
                                  className={`font-bold text-center rounded-md py-1.5 border border-[var(--theme-border)] bg-[var(--theme-bg)] text-[var(--theme-text)] ${fontBody}`}
                                >
                                  {item.value}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {correctScoresFull.draw?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresFull.draw.map((item, idx) => (
                              <div
                                key={idx}
                                className="flex flex-col gap-1.5 min-w-0 shrink-0"
                              >
                                <div
                                  className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}
                                >
                                  {item.label}
                                </div>
                                <div
                                  className={`font-bold text-center rounded-md py-1.5 border border-[var(--theme-border)] bg-[var(--theme-bg)] text-[var(--theme-text)] ${fontBody}`}
                                >
                                  {item.value}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {correctScoresFull.away?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresFull.away.map((item, idx) => (
                              <div
                                key={idx}
                                className="flex flex-col gap-1.5 min-w-0 shrink-0"
                              >
                                <div
                                  className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}
                                >
                                  {item.label}
                                </div>
                                <div
                                  className={`font-bold text-center rounded-md py-1.5 border border-[var(--theme-border)] bg-[var(--theme-bg)] text-[var(--theme-text)] ${fontBody}`}
                                >
                                  {item.value}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {totalCornersOdds.length > 0 && (
                  <div className="flex flex-col gap-1">
                    <div
                      className={`font-bold text-[var(--theme-text-muted)] ${fontBody}`}
                    >
                      Tổng Phạt Góc
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {totalCornersOdds.map((item, idx) => (
                        <div
                          key={idx}
                          className={`flex items-center gap-2 rounded-md py-1 px-2 border border-[var(--theme-border)] bg-[var(--theme-bg)] text-[var(--theme-text)] ${fontBody}`}
                        >
                          <span>{dreamnDisplayValue(item?.totalCorners)}</span>
                          <span className="flex items-center gap-0.5">
                            Tài {dreamnDisplayValue(item?.over)}
                            <DreamnOtherBetsStatus
                              trend={item?.initialOverTrend}
                            />
                          </span>
                          <span className="flex items-center gap-0.5">
                            Xỉu {dreamnDisplayValue(item?.under)}
                            <DreamnOtherBetsStatus
                              trend={item?.initialUnderTrend}
                            />
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}

            {activeOtherTab === "half" && (
              <>
                {correctScoresListHalf.length > 0 && (
                  <div className="flex flex-col gap-1">
                    <div
                      className={`font-bold text-[var(--theme-text-muted)] ${fontBody}`}
                    >
                      Tổng tỷ số
                    </div>
                    <div className="grid grid-cols-3 gap-1 mb-0.25 text-center font-bold text-[10px] text-[var(--theme-text-muted)]">
                      {correctScoresHalf.home?.length > 0 && (
                        <div className="py-1.5 px-2">Tỉ Số Thắng Đội Nhà</div>
                      )}
                      {correctScoresHalf.draw?.length > 0 && (
                        <div className="py-1.5 px-2">Tỉ Số Hòa</div>
                      )}
                      {correctScoresHalf.away?.length > 0 && (
                        <div className="py-1.5 px-2">Tỉ Số Thắng Đội Khách</div>
                      )}
                    </div>
                    <div className="max-h-[250px] overflow-y-auto min-h-0">
                      <div className="grid grid-cols-3 gap-2.5">
                        {correctScoresHalf.home?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresHalf.home.map((item, idx) => (
                              <div
                                key={idx}
                                className="flex flex-col gap-1.5 min-w-0 shrink-0"
                              >
                                <div
                                  className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}
                                >
                                  {item.label}
                                </div>
                                <div
                                  className={`font-bold text-center rounded-md py-1.5 border border-[var(--theme-border)] bg-[var(--theme-bg)] text-[var(--theme-text)] ${fontBody}`}
                                >
                                  {item.value}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {correctScoresHalf.draw?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresHalf.draw.map((item, idx) => (
                              <div
                                key={idx}
                                className="flex flex-col gap-1.5 min-w-0 shrink-0"
                              >
                                <div
                                  className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}
                                >
                                  {item.label}
                                </div>
                                <div
                                  className={`font-bold text-center rounded-md py-1.5 border border-[var(--theme-border)] bg-[var(--theme-bg)] text-[var(--theme-text)] ${fontBody}`}
                                >
                                  {item.value}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {correctScoresHalf.away?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresHalf.away.map((item, idx) => (
                              <div
                                key={idx}
                                className="flex flex-col gap-1.5 min-w-0 shrink-0"
                              >
                                <div
                                  className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}
                                >
                                  {item.label}
                                </div>
                                <div
                                  className={`font-bold text-center rounded-md py-1.5 border border-[var(--theme-border)] bg-[var(--theme-bg)] text-[var(--theme-text)] ${fontBody}`}
                                >
                                  {item.value}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {totalCornersHalfOdds.length > 0 && (
                  <div className="flex flex-col gap-1">
                    <div
                      className={`font-bold text-[var(--theme-text-muted)] ${fontBody}`}
                    >
                      Tổng Phạt Góc
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {totalCornersHalfOdds.map((item, idx) => (
                        <div
                          key={idx}
                          className={`flex items-center gap-2 rounded-md py-1 px-2 border border-[var(--theme-border)] bg-[var(--theme-bg)] text-[var(--theme-text)] ${fontBody}`}
                        >
                          <span>{dreamnDisplayValue(item?.totalCorners)}</span>
                          <span className="flex items-center gap-0.5">
                            Tài {dreamnDisplayValue(item?.over)}
                            <DreamnOtherBetsStatus
                              trend={item?.initialOverTrend}
                            />
                          </span>
                          <span className="flex items-center gap-0.5">
                            Xỉu {dreamnDisplayValue(item?.under)}
                            <DreamnOtherBetsStatus
                              trend={item?.initialUnderTrend}
                            />
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
